module.exports = __webpack_public_path__ + "static/media/edit_icon_white.4de2265f.svg";